import SelectorResultsWrapperPresentation from 'components/SelectorResultsWrapper/SelectorResultsWrapperPresentation'

export default {
  Presentation: SelectorResultsWrapperPresentation,
}
